"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTabs = useTabs;
var React = _interopRequireWildcard(require("react"));
var _utils = require("@mui/utils");
var _useCompound = require("../useCompound");
/**
 *
 * Demos:
 *
 * - [Tabs](https://mui.com/base-ui/react-tabs/#hooks)
 *
 * API:
 *
 * - [useTabs API](https://mui.com/base-ui/react-tabs/hooks-api/#use-tabs)
 */ function useTabs(parameters) {
    var valueProp = parameters.value, defaultValue = parameters.defaultValue, onChange = parameters.onChange, _parameters_orientation = parameters.orientation, orientation = _parameters_orientation === void 0 ? 'horizontal' : _parameters_orientation, _parameters_direction = parameters.direction, direction = _parameters_direction === void 0 ? 'ltr' : _parameters_direction, _parameters_selectionFollowsFocus = parameters.selectionFollowsFocus, selectionFollowsFocus = _parameters_selectionFollowsFocus === void 0 ? false : _parameters_selectionFollowsFocus;
    var _ref = _sliced_to_array((0, _utils.unstable_useControlled)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Tabs',
        state: 'value'
    }), 2), value = _ref[0], setValue = _ref[1];
    var onSelected = React.useCallback(function(event, newValue) {
        setValue(newValue);
        onChange === null || onChange === void 0 ? void 0 : onChange(event, newValue);
    }, [
        onChange,
        setValue
    ]);
    var _ref1 = (0, _useCompound.useCompoundParent)(), tabPanels = _ref1.subitems, compoundComponentContextValue = _ref1.contextValue;
    var tabIdLookup = React.useRef(function() {
        return undefined;
    });
    var getTabPanelId = React.useCallback(function(tabValue) {
        var _tabPanels_get;
        return (_tabPanels_get = tabPanels.get(tabValue)) === null || _tabPanels_get === void 0 ? void 0 : _tabPanels_get.id;
    }, [
        tabPanels
    ]);
    var getTabId = React.useCallback(function(tabPanelId) {
        return tabIdLookup.current(tabPanelId);
    }, []);
    var registerTabIdLookup = React.useCallback(function(lookupFunction) {
        tabIdLookup.current = lookupFunction;
    }, []);
    return {
        contextValue: _object_spread({
            direction: direction,
            getTabId: getTabId,
            getTabPanelId: getTabPanelId,
            onSelected: onSelected,
            orientation: orientation,
            registerTabIdLookup: registerTabIdLookup,
            selectionFollowsFocus: selectionFollowsFocus,
            value: value
        }, compoundComponentContextValue)
    };
}
